/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Group_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Event Group name" |
*
* @param {Subtitle_Extract_Group_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_group_name_label = /** @type {((inputs?: Subtitle_Extract_Group_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Group_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name der Veranstaltungsgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动组名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループ名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do grupo de eventos")
	return /** @type {LocalizedString} */ ("Event Group name")
});